<template>
  <v-app id="app">
    <router-view/>
    <popup-whats></popup-whats>
  </v-app>
</template>

<script defer>
/* eslint-disable */
import AOS from 'aos'
  export default {
    name: 'App',
    components: {
      PopupWhats: () => import('./components/PopupWhats.vue')
    },
    created () {
      AOS.init({})
    }
  }
</script>
<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
